import React, { FC, useContext } from 'react';
import styles from './CustomSettingsForm.module.scss';
import { Button, Select } from 'esa-ui-library';
import { Form, PERMISSIONS } from '../../../..';
import { useStore } from '../../../../../common';
import { AuthContext } from '../../../../../logic';

type ValueType = {
	label: string;
	value: string;
};

interface CustomSettingsFormProps {
	onSubmit: () => void;
}

const CustomSettingsForm: FC<CustomSettingsFormProps> = ({ onSubmit }): JSX.Element => {
	const { user } = useContext(AuthContext);
	const [state, dispatch] = useStore();
	const { languages, activeLanguage, currencies, activeCurrency, dateTimes, activeDateTime, errors, success } = state;
	const canChangeUserDetails = user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canChangeUserDetails];

	const onLanguageChange = (val: ValueType[]) => {
		dispatch('LANGUAGE', val);
	};

	const onDateTimeChange = (val: ValueType[]) => {
		dispatch('DATE_TIME', val);
	};

	const onCurrencyChange = (val: ValueType[]) => {
		dispatch('CURRENCY', val);
	};

	return (
		<section className={styles.CustomSettingsForm}>
			<Form errors={errors} success={success}>
				<Select
					label='Default language'
					options={languages}
					placeholder='Select language'
					selected={activeLanguage}
					dataId='language-field'
					disabled={!canChangeUserDetails}
					onChange={onLanguageChange}
				/>
				<Select
					label='Currency'
					options={currencies}
					placeholder='Select currency'
					selected={activeCurrency}
					dataId='currency-field'
					disabled={!canChangeUserDetails}
					onChange={onCurrencyChange}
				/>
				<Select
					label='Date/Time format'
					options={dateTimes}
					placeholder='Select date/time format'
					selected={activeDateTime}
					dataId='date-format-field'
					disabled={!canChangeUserDetails}
					onChange={onDateTimeChange}
				/>
				<Button
					title='Save Changes'
					primary
					dataId='submit-button'
					disabled={!canChangeUserDetails}
					onClick={onSubmit}
				/>
			</Form>
		</section>
	);
};

export { CustomSettingsForm };
